import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { LegalForm } from './legal-form.interface';
import { LegalFormService } from './legal-form.service';

const service = new LegalFormService();

export interface legalformState {
   legalForms: Array<LegalForm>;
}

const legalformStore: Module<legalformState, StoreState> = {
   namespaced: true,
   state: {
      legalForms: [],
   },
   getters: {
      legalForms: (state) => state.legalForms,
   },
   mutations: {
      SET_LEGAL_FORMS(state, legalForms: Array<LegalForm>) {
         state.legalForms = legalForms;
      },
   },
   actions: {
      async getLegalForms(context, query?: LocationQuery) {
         const response = await service.getLegalForms(query);
         context.commit('SET_LEGAL_FORMS', response.data);
         return response;
      },
   },
};

export default legalformStore;
